import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts);
Theme(Highcharts);

const NewBarChartDefaultMini: any = (props: any) => {
    const  {allData, exportExcel,exportarImagen ,labels, title,subtitle, idChart, activeButton, colores,formatDataStringData,numDecimalProps,pieTextProps,showPieTextInGraph,showSeries,titleY,mostrarlegend,bottonLegend ,sharedTooltip,showCategory,yAxisMax,isYAxisActive} =  props;

    const options = {
        chart: {
            type: 'column',
            height: 300,
            width: 300,
            backgroundColor: '#ffffff'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        yAxis: {
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			enabled: isYAxisActive,
			max: yAxisMax?yAxisMax:undefined,
			title: {
				enabled: (titleY !== null && titleY !== undefined && titleY.trim() !== '') ? true : false,
				text: titleY, // Aquí puedes cambiar el título del eje Y
			},
			reversed: false,
			labels:{
				enabled: isYAxisActive,
				format: '{value}'+formatDataStringData,
				style: {
					fontFamily: 'Montserrat, sans-serif',
					color: '#19355F'
				  }
			}
		},

        xAxis: {
			labels:{
				enabled: showCategory,
			},
			gridLineWidth: 0,
			categories : labels,
			max: (labels.length - 1),
			//@ts-ignore
			formatter: function () {
				//@ts-ignore
				return `<div style="width: 100px;"><Textfit mode="multi">${this.value}</Textfit></div>`;
			  },
			  useHTML: true
		},
        tooltip: {
			shared: sharedTooltip,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: center"><b>{point.y}'+formatDataStringData+'</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: numDecimalProps
		},
    	plotOptions: {
			series: {
				dataLabels: {
					formatter: function(this: Highcharts.PointLabelObject) {
						// Definir una condición para decidir cuántos decimales mostrar
						//@ts-ignore
						if (numDecimalProps === 0) {
							//@ts-ignore
						  return  '<span style="color:' + this.point.color + '">' + this.y.toFixed(0)+ (formatDataStringData?formatDataStringData:'') +'</span>' ; // Mostrar sin decimales si es un número entero
						} else {
							//@ts-ignore
							return  '<span style="color:' + this.point.color + '">' +this.y.toFixed(numDecimalProps)+ (formatDataStringData?formatDataStringData:'') +'</span>' ; // Mostrar sin decimales si es un número entero

						}
					  },
				align: 'center',
				enabled: showSeries,
				inside: false
				},
				grouping: true
			}
		},
        credits: {
            enabled: false
        },
        series: allData,
        colors: colores,
        legend: {
            enabled: {mostrarlegend}
        },
        exporting: {
            enabled: false
        }
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    );
}

export default NewBarChartDefaultMini;